module.exports = __webpack_public_path__ + "static/media/Flip-Coin-1.3baded16.png";